import { render, staticRenderFns } from "./OrganizationBusinessRoleSection.vue?vue&type=template&id=96255850&"
import script from "./OrganizationBusinessRoleSection.vue?vue&type=script&lang=js&"
export * from "./OrganizationBusinessRoleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports